import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = { "data-quick-links": "" };
const _hoisted_2 = {
    key: 1,
    class: "container grid-layout"
};
const _hoisted_3 = {
    key: 2,
    class: "container flex flex-wrap gap-5 pt-10"
};
import SectionHeader from '@molecules/SectionHeader.vue';
import QuickLinkCard from '@atoms/QuickLinkCard.vue';
import { hyphenate } from '@helpers/text';
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuickLinks',
    props: {
        quickLinks: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.quickLinks.displayOptions.includes('title') && __props.quickLinks.title)
                    ? (_openBlock(), _createBlock(SectionHeader, {
                        key: 0,
                        title: __props.quickLinks.title,
                        class: "mb-3 !bg-grey-50 lg:mb-5"
                    }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
                (__props.quickLinks.displayOptions.includes('images'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quickLinks.posts, (post, index) => {
                            return (_openBlock(), _createBlock(QuickLinkCard, {
                                key: `${_unref(hyphenate)(post.title)}-${index}`,
                                post: post,
                                displayOptions: __props.quickLinks.displayOptions
                            }, null, 8, ["post", "displayOptions"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                (!__props.quickLinks.displayOptions.includes('images'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quickLinks.posts, (post, index) => {
                            return (_openBlock(), _createBlock(ButtonWithArrow, {
                                key: `${_unref(hyphenate)(post.title)}-${index}`,
                                target: post.target,
                                text: post.title,
                                url: post.url
                            }, null, 8, ["target", "text", "url"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
